// extracted by mini-css-extract-plugin
export default {"card":"cancel-order_card__TlT4K","title":"cancel-order_title__WS5x3","text":"cancel-order_text__rZbX4","btns":"cancel-order_btns__WsG2l"};